function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1944(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34.98,
    height: 17.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.19375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 8.775,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.55,
    width: 34.98,
    height: 30.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 33.03,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.51,
    width: 34.98,
    height: 32.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 64.58,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.65,
    width: 34.98,
    height: 40.17,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.829999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 100.73500000000001,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 120.82,
    width: 34.98,
    height: 40.62,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8866666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 141.13,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.44,
    width: 34.98,
    height: 42.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.997142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 182.46,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.48,
    width: 34.98,
    height: 43.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9959999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 225.095,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 246.71,
    width: 34.98,
    height: 44.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 269.035,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 291.36,
    width: 34.98,
    height: 46.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.829999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 314.375,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.39,
    width: 34.98,
    height: 47.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 361.09999999999997,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 384.81,
    width: 34.98,
    height: 56.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.997142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 413.085,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 441.36,
    width: 34.98,
    height: 61.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 472.17,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 502.98,
    width: 34.98,
    height: 64.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 535.355,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 567.73,
    width: 34.98,
    height: 65.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.997142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 600.455,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 633.17,
    width: 34.98,
    height: 66.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.49,
    y: 666.5849999999999,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 0,
    width: 45.08,
    height: 53.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.513333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.519999999999996,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.06,
    y: 0,
    width: 46.16,
    height: 53.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.14,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.22,
    y: 0,
    width: 46.19,
    height: 53.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.619
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.315,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.41,
    y: 0,
    width: 46.43,
    height: 53.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.625,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.84,
    y: 0,
    width: 50.05,
    height: 53.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.25625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.865,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.89,
    y: 0,
    width: 50.27,
    height: 53.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.378333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.025,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.15,
    y: 0,
    width: 51.92,
    height: 53.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.10999999999996,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.08,
    y: 0,
    width: 52,
    height: 53.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.666666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.08,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.07,
    y: 0,
    width: 53.37,
    height: 53.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.755,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.45,
    y: 0,
    width: 55.47,
    height: 53.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.971111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.185,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.92,
    y: 0,
    width: 56.01,
    height: 53.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.925,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.92,
    y: 0,
    width: 56.02,
    height: 53.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.93,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.94,
    y: 0,
    width: 56.06,
    height: 53.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.956666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.97,
    y: 26.87,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 53.74,
    width: 59.74,
    height: 50.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 79.175,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 104.61,
    width: 59.74,
    height: 51.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 130.24,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 155.87,
    width: 59.74,
    height: 52.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.524285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 182.205,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 208.54,
    width: 59.74,
    height: 56.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1463636363636365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 236.845,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 265.15,
    width: 59.74,
    height: 57.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.15857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 293.705,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 322.25,
    width: 59.74,
    height: 59.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 351.955,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 381.66,
    width: 59.74,
    height: 60.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 411.995,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 442.33,
    width: 59.74,
    height: 60.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 472.78999999999996,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 503.25,
    width: 59.74,
    height: 63.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.956666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 534.865,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 566.48,
    width: 59.74,
    height: 65.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.637777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 599.1850000000001,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 631.88,
    width: 59.74,
    height: 68.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.956666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.85,
    y: 665.94,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 53.74,
    width: 57.94,
    height: 71.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.656666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.67999999999999,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.66,
    y: 53.74,
    width: 64.59,
    height: 71.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.918000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.95499999999998,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 53.74,
    width: 65.38,
    height: 71.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.94,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.63,
    y: 53.74,
    width: 65.44,
    height: 71.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.35,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.07,
    y: 53.74,
    width: 65.56,
    height: 71.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.85,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.64,
    y: 53.74,
    width: 69.98,
    height: 71.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.775555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.63,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.61,
    y: 53.74,
    width: 71.06,
    height: 71.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.14,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.67,
    y: 53.74,
    width: 72.09,
    height: 71.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.242857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 590.7149999999999,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.76,
    y: 53.74,
    width: 73.24,
    height: 71.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.38,
    y: 89.59,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 125.44,
    width: 74.11,
    height: 76.24,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.587142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 163.56,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 201.68,
    width: 74.11,
    height: 76.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.5275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 240.055,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 278.43,
    width: 74.11,
    height: 80.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.822
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 318.78000000000003,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 359.13,
    width: 74.11,
    height: 81.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.5275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 399.90999999999997,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 440.7,
    width: 74.11,
    height: 82.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.26375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 481.885,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 523.06,
    width: 74.11,
    height: 85.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.234444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 565.81,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.71,
    y: 608.56,
    width: 74.11,
    height: 91.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.411
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.765,
    y: 654.28,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.82,
    y: 125.44,
    width: 72.63,
    height: 102.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.375714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.135,
    y: 176.48,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.45,
    y: 125.44,
    width: 78.44,
    height: 102.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.687999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.66999999999996,
    y: 176.48,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.89,
    y: 125.44,
    width: 89.98,
    height: 102.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.997777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.88,
    y: 176.48,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.87,
    y: 125.44,
    width: 94.08,
    height: 102.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.91,
    y: 176.48,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.95,
    y: 125.44,
    width: 94.29,
    height: 102.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.571818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.095,
    y: 176.48,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.24,
    y: 125.44,
    width: 101.76,
    height: 102.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.12,
    y: 176.48,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.82,
    y: 227.52,
    width: 95.15,
    height: 113.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.89375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.39499999999998,
    y: 284.2,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.82,
    y: 340.88,
    width: 95.15,
    height: 118.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.572222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.39499999999998,
    y: 400.37,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.82,
    y: 459.85,
    width: 95.15,
    height: 119.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.592857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.39499999999998,
    y: 519.69,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.82,
    y: 579.53,
    width: 95.15,
    height: 120.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.89375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.39499999999998,
    y: 639.765,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.97,
    y: 227.52,
    width: 95.81,
    height: 123.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.645555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.875,
    y: 289.43,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.78,
    y: 227.52,
    width: 104.54,
    height: 123.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.04999999999995,
    y: 289.43,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.32,
    y: 227.52,
    width: 104.69,
    height: 123.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.938
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.665,
    y: 289.43,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.01,
    y: 227.52,
    width: 130.99,
    height: 123.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.505,
    y: 289.43,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.97,
    y: 351.34,
    width: 63.65,
    height: 348.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.795,
    y: 525.67,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.62,
    y: 351.34,
    width: 372.38,
    height: 348.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.81,
    y: 525.67,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1944);
export default __webpack_public_path__ + "static/media/1944.8ce911205a19d4377cc9127d2f532525.svg";
export { ForwardRef as ReactComponent };